var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05FatcaDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{fill:#E0E0E0;}\r\n\t.st2{fill:#F0F0F0;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#F0F0F0;stroke:#E0E0E0;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{display:none;}\r\n\t.st6{display:inline;}\r\n\t.st7{fill:#407BFF;}\r\n\t.st8{opacity:0.9;fill:#FFFFFF;}\r\n\t.st9{fill:#F5F5F5;}\r\n\t.st10{fill:#042b62;}\r\n\t.st11{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st13{opacity:0.5;}\r\n\t.st14{opacity:0.2;}\r\n\t.st15{opacity:0.1;}\r\n\t.st16{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st17{fill:none;stroke:#263238;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st18{fill:#EBC0BB;}\r\n\t.st19{fill:#EEC1BB;}\r\n\t.st20{fill:#263238;}\r\n\t.st21{fill:#D4827D;}\r\n\t.st22{fill:#FFC2BC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.8,
    y: 398.5,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.5,
    y: 401.2,
    className: "st0",
    width: 8.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 389.2,
    className: "st0",
    width: 19.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 390.9,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 390.9,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 395.1,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,337.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7H237c3.1,0,5.7,2.6,5.7,5.7v271.4 C242.7,335.2,240.2,337.8,237,337.8z M43.9,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5V60.7 c0-3-2.4-5.5-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,337.8H260.2c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.6,5.7,5.7v271.4 C459,335.2,456.5,337.8,453.3,337.8z M260.2,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5V60.7 c0-3-2.4-5.5-5.5-5.5H260.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.7,
    y: 113.8,
    className: "st1",
    width: 5.2,
    height: 110.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 113.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 736.2108 337.8451)",
    className: "st1",
    width: 99.6,
    height: 110.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.1,
    y: 113.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 733.5529 337.8451)",
    className: "st2",
    width: 103.3,
    height: 110.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.5,
    y: 117.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 733.7176 336.2971)",
    className: "st3",
    width: 94.7,
    height: 101.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.5,
    y: 117.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 641.7127 336.2971)",
    className: "st1",
    width: 2.7,
    height: 101.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.8,
    y: 145.5,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 176.4244 559.983)",
    className: "st1",
    width: 2.7,
    height: 92.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.5,
    y: 185.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 735.1871 376.2193)",
    className: "st2",
    width: 96.2,
    height: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 183.2,
    className: "st2",
    width: 156.5,
    height: 198.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 190.4,
    className: "st1",
    width: 145.5,
    height: 42.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 197.3,
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 197.3,
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 196.8,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -34.0616 30.9911)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 202,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.8,
    y: 202,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.8,
    y: 202,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 201.4,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -43.9425 33.3568)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 195.5,
    className: "st0",
    width: 4.1,
    height: 37.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.3,
    y: 195.5,
    className: "st0",
    width: 4.1,
    height: 37.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 239.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 288.6497 521.4059)",
    className: "st1",
    width: 145.5,
    height: 42.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 246.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 425.8557 528.2678)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.8,
    y: 246.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 345.94 528.2678)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 245.9,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 202.4678 544.7)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.6,
    y: 251.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 405.3768 532.9493)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.6,
    y: 251.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 367.389 532.9493)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: 251.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 271.5034 532.9493)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 250.5,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 255.8803 559.9775)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.4,
    y: 244.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 386.9538 526.5041)",
    className: "st0",
    width: 4.1,
    height: 37.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.3,
    y: 244.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 288.6496 526.5041)",
    className: "st0",
    width: 4.1,
    height: 37.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 246.4,
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 251.1,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.8,
    y: 251.1,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 244.6,
    className: "st0",
    width: 4.1,
    height: 37.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 288.6,
    className: "st1",
    width: 145.5,
    height: 42.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 155.1,
    y: 295.5,
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.5,
    y: 295,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -50.1066 39.812)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.4,
    y: 300.2,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.4,
    y: 300.2,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.3,
    y: 300.2,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 299.6,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -64.2054 45.1379)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 293.7,
    className: "st0",
    width: 4.1,
    height: 37.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.8,
    y: 293.7,
    className: "st0",
    width: 4.1,
    height: 37.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.5,
    y: 295,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -51.4884 23.6657)",
    className: "st0",
    width: 8.3,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.2,
    y: 300.2,
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.3,
    y: 299.6,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -66.4697 24.5164)",
    className: "st0",
    width: 8.3,
    height: 30.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.7,
    y: 293.7,
    className: "st0",
    width: 4.1,
    height: 37.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -15.2229 24.8287)",
    className: "st1",
    cx: 146.4,
    cy: 106.8,
    rx: 23.6,
    ry: 23.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -15.2229 24.8287)",
    className: "st2",
    cx: 146.4,
    cy: 106.8,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "145.4,120.6 145.4,106.6 136.2,111.8  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.7,110.3C111.6,50.8,210.8,59.2,249,101c38.3,41.8,50.7,68.6,85.2,53c34.5-15.6,78.5-11.4,81,38.2 c2.5,49.6-37.9,108.3-102.1,125.6c-64.2,17.4-64.2,78.8-149.1,66.4c-46.3-6.8-47.4-56.9-40.8-98.3S51.3,179.2,83.7,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.7,110.3C111.6,50.8,210.8,59.2,249,101c38.3,41.8,50.7,68.6,85.2,53c34.5-15.6,78.5-11.4,81,38.2 c2.5,49.6-37.9,108.3-102.1,125.6c-64.2,17.4-64.2,78.8-149.1,66.4c-46.3-6.8-47.4-56.9-40.8-98.3S51.3,179.2,83.7,110.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    className: "st9",
    cx: 250,
    cy: 416.2,
    rx: 193.9,
    ry: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "From_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 147.8,
    className: "st10",
    width: 134.2,
    height: 225.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 147.8,
    className: "st11",
    width: 134.2,
    height: 225.4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "From_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 141.8,
    className: "st10",
    width: 134.2,
    height: 225.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.7,
    y: 141.8,
    className: "st12",
    width: 134.2,
    height: 225.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 273.5,
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 278.4,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 284.6,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 216.5,
    className: "st13",
    width: 96.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 221.4,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 229.2,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 236.5,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 243.8,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 251.1,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 258.4,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 230,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 237.3,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 244.6,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 251.9,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 259.2,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 229.2,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 236.5,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 243.8,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 251.1,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.7,
    y: 258.4,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 230,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 237.3,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 244.6,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 251.9,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 259.2,
    className: "st13",
    width: 46.5,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 152.5,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 157.4,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 163.5,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 170.9,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 170.9,
    className: "st14",
    width: 57.8,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 178.3,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 178.3,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 178.3,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 185.7,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 185.7,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 185.7,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 193.1,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 193.1,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 193.1,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.9,
    y: 200.5,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.4,
    y: 200.5,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 200.5,
    className: "st15",
    width: 28.5,
    height: 6.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 298.6,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 303.4,
    className: "st13",
    width: 49.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 309.6,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 322.6,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 327.5,
    className: "st13",
    width: 74.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 333.6,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.2,
    y: 358,
    className: "st13",
    width: 3.7,
    height: 2
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "From_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 118,
    className: "st10",
    width: 134.2,
    height: 225.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 118,
    className: "st16",
    width: 134.2,
    height: 225.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.5,
    y: 118,
    className: "st10",
    width: 134.2,
    height: 19.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.3,124.9h-2.8v-1.3h7.1v1.3h-2.8v7.1h-1.6V124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.8,130h-4.2l-0.8,1.9h-1.6l3.8-8.4h1.5l3.8,8.4h-1.6L170.8,130z M170.3,128.8l-1.6-3.7l-1.6,3.7H170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M179.2,131.9l-2.3-3.2l-2.3,3.2h-1.8l3.1-4.3l-3-4.1h1.8l2.1,3l2.1-3h1.7l-2.9,4.1l3.2,4.3H179.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 283,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 275.3,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 267.6,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 283,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 275.3,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 267.6,
    cy: 113.9,
    r: 2.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 143.7,
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 148.6,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 154.7,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 166.7,
    className: "st13",
    width: 96.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 171.6,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 179.4,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 186.7,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 194,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 201.3,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.5,
    y: 208.6,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 180.2,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 187.5,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 194.8,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 202.1,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 209.4,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 179.4,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 186.7,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 194,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 201.3,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.5,
    y: 208.6,
    className: "st14",
    width: 3.6,
    height: 3.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 180.2,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 187.5,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 194.8,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 202.1,
    className: "st13",
    width: 46.5,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 209.4,
    className: "st13",
    width: 46.5,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 219.8,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 224.6,
    className: "st13",
    width: 89.4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 230.8,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 238.2,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 238.2,
    className: "st14",
    width: 57.8,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 245.6,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 245.6,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 245.6,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 253,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 253,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 253,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 260.4,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 260.4,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 260.4,
    className: "st15",
    width: 28.5,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.7,
    y: 267.8,
    className: "st15",
    width: 57.6,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.2,
    y: 267.8,
    className: "st15",
    width: 28.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 267.8,
    className: "st15",
    width: 28.5,
    height: 6.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 280.8,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 285.7,
    className: "st13",
    width: 49.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 291.8,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 302.8,
    className: "st13",
    width: 64.9,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 307.7,
    className: "st13",
    width: 74.4,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 160.3,
    y: 313.8,
    className: "st14",
    width: 116.3,
    height: 6.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 334.2,
    className: "st13",
    width: 3.7,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M163,158.4c0,0,8.2-1.6,9-1.3c0.7,0.3-0.3,3.1,3.7,2c4-1.1,8.2-2.6,7.9-1.7c-0.3,0.8,2.5,1,4,1 c1.6,0,4.2-1.3,4.2-1.3s-0.1-0.8,1.1,0.3c1.1,1,5.5,1,7.1,0.7c1.6-0.3,2.8,1,2.8,1s9.5-2.1,10.7-2c1.2,0.1,1.6,2.1,2.9,2 c1.4-0.1,9.7-1.3,10.7-1c1,0.3,32.8,0.3,32.8,0.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "273.4,180.7 274.2,181.6 275.3,180.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "273.4,188.3 274.2,189.2 275.3,187.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "211.4,180.7 212.3,181.6 213.3,180.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "211.3,188.3 212.2,189.2 213.2,187.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "211.4,203 212.3,203.9 213.3,202.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st17",
    points: "211.3,210.2 212.2,211.1 213.2,209.7  "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M343,205.6c-3.8,2.7-7.5,5.1-11.6,7.3c-2,1.1-4.1,2.1-6.3,3c-2.2,0.9-4.5,1.8-7.5,2.2 c-0.4,0.1-0.8,0.1-1.2,0.1c-0.2,0-0.4,0-0.7,0c-0.3,0-0.6,0-0.9,0c-1.1-0.1-2-0.4-2.7-0.6c-1.5-0.6-2.6-1.2-3.7-1.9 c-2.1-1.3-3.9-2.8-5.7-4.3c-3.5-3-6.5-6.2-9.4-9.7c-0.9-1.1-0.8-2.8,0.4-3.7c0.9-0.8,2.2-0.8,3.2-0.1l0.1,0 c3.5,2.4,7.1,4.9,10.7,7.1c1.8,1.1,3.6,2.1,5.2,2.9c0.8,0.4,1.7,0.7,2.3,0.8c0.3,0.1,0.5,0.1,0.5,0.1c0,0-0.1,0-0.1,0 c0,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4-0.1c1.3-0.3,3.2-1.1,4.9-1.9c1.8-0.9,3.6-1.9,5.3-2.9c3.5-2.1,7.2-4.5,10.6-6.8l0.1-0.1 c2.4-1.6,5.7-1,7.3,1.4C345.8,200.7,345.3,203.9,343,205.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M345.8,192.5c-8.5-1.5-11.8,3.3-21.8,11.8c1,9.3,8,13.3,8,13.3S352.8,204,345.8,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M345.4,204c-3.6,6.6-11.3,12.2-13,13.3c-0.2,0.1-0.3,0.2-0.3,0.2s-7-4-8-13.3c10-8.5,13.3-13.3,21.8-11.8 C348.1,196.3,347.4,200.3,345.4,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M288.1,192.4l2.6-0.2c1-0.1,1.9,0.3,2.6,1.1l2.9,3.6c1.2,1.4,1.6,3.3,1.1,5.1l-0.3,1.1c-4.3,0.6-9.4-2-9.4-2 l-1.5-0.6c-1.4-0.5-2.1-1.9-1.6-3.2l1.1-3C285.9,193.2,286.9,192.5,288.1,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M345.4,204c-3.6,6.6-11.3,12.2-13,13.3c0.6-3,2.5-9.4,8.1-13.5C342.3,202.5,344,202.8,345.4,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M344.7,158.1c0,0-7.6,19,0,35.6c7.6,16.6,29,6.6,31.1,2.7c2.1-4-2.8-12.1-2.8-19.5s1.8-11.5,0.5-17.5 C372.1,153.2,344.7,158.1,344.7,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M365.9,247.3c0,0-0.5,8.4-4.6,23c-2.1,7.4-5,16.4-9.3,26.7c-2,4.9-4.4,10.1-7.1,15.6c-1.2,2.5-2.5,5-3.9,7.6 c-1.6,44.4-26.5,89.5-26.5,89.5c-1.4,0.7-6.2-0.1-6.2-1.5c3.7-5.9,11-62.8,15.6-89.7c0.3-3.7,0.7-7.6,1.2-11.7 c1.4-10.9,3.4-22.7,5.4-33.2c3.1-16.4,6-29.3,6-29.3l8.2,0.8L365.9,247.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M375.6,308.7L375.6,308.7c-0.7,4.8-1.5,9.9-2.6,15.3c8.9,29.7-9.4,87.6-9.4,87.6c-3.1,0.6-5.8,0.2-7.2-0.8 c3.4-17.5,1-62.9-1.7-90c-0.2-2.5-0.5-5.2-0.9-8.1c-0.6-4.9-1.2-10.3-1.9-15.9c-1.2-9.3-2.5-19.2-3.7-27.9 c-1.5-10.5-2.7-19.4-3.4-23.9c-0.3-2-0.4-3.1-0.4-3.1l25.7,2.8c0,0,6.5,7.3,7.5,30.2C378,283.9,377.6,294.9,375.6,308.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M375.6,308.7L375.6,308.7c-8.1,2.6-15.4,3.8-21.8,4.1c-0.6-4.9-1.2-10.3-1.9-15.9c-2,4.9-4.4,10.1-7.1,15.6 c-8.8-0.9-15.4-3.5-19.6-5.7c1.4-10.9,3.4-22.7,5.4-33.2c2.4-1.4,5.3-2.6,8.7-3.5c2.7-0.7,5.7-1,8.9-1.1c4.1-0.1,8.6,0.4,13,1.2 c5.6,1,11.3,2.7,16.4,4.8C378,283.9,377.6,294.9,375.6,308.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M375.8,193.2c0,0-1.8,6.6-3.3,17.2c-0.5,3.2-0.9,6.8-1.3,10.7c-0.7,7.1-1.1,15.1-0.9,23.7h-33.8 c0,0-5.3-39.6,3.5-52.3C340,192.5,357.3,184.3,375.8,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M372.5,210.4c-0.5,3.2-0.9,6.8-1.3,10.7c-1.5-3.1-3.4-10.4-1-18.2L372.5,210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M356,223.2l2.6,0c1,0,1.9,0.5,2.5,1.3l2.6,3.8c1.1,1.5,1.3,3.4,0.7,5.1l-0.4,1.1c-4.3,0.3-9.2-2.6-9.2-2.6 l-1.5-0.7c-1.3-0.6-1.9-2.1-1.3-3.3l1.3-3C353.8,223.9,354.8,223.2,356,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M358.3,186.8c10.6,0,11.9,8.7,11.9,8.7l-5-2.1l-14.6,9.8l-3.6-9.8l-4.5,0.8 C342.6,194.1,349.1,186.8,358.3,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M358.3,186.8c10.6,0,11.9,8.7,11.9,8.7l-5-2.1l-14.6,9.8l-3.6-9.8l-4.5,0.8 C342.6,194.1,349.1,186.8,358.3,186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M351.2,202.5l13.7-11.9c-3.3-3.4-1.6-12.8-0.2-17.9l-10.4,8.3c0.7,4,0.5,8.2-5.3,9.6 C349,190.6,351.2,202.5,351.2,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M360.4,176.1l-6.1,4.9c0.2,0.9,0.3,1.9,0.3,2.8c2.2-0.3,5.4-2.7,5.8-5C360.5,177.7,360.5,176.7,360.4,176.1z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M369,162.5c-1.6,8.3-2,11.8-6.7,15.7c-7.1,6-16.8,2.8-17.8-5.6c-0.8-7.6,1.8-19.8,10.3-22.5 C363.2,147.4,370.5,154.2,369,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M361.9,156.5c4.6,5.9-4.8,12.6,4.6,12.3c9.4-0.4,5.6-13.6,0-16.6C360.9,149.1,361.9,156.5,361.9,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M355.9,163.8c-0.1,0.7-0.5,1.2-1,1.2c-0.4,0-0.7-0.6-0.6-1.3c0.1-0.7,0.5-1.2,1-1.2 C355.7,162.5,356,163.1,355.9,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M347.5,163.3c-0.1,0.7-0.5,1.2-1,1.2c-0.4,0-0.7-0.6-0.6-1.3c0.1-0.7,0.5-1.2,1-1.2 C347.3,162,347.6,162.6,347.5,163.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M347,162.1l-1.6-0.6C345.5,161.5,346.1,162.8,347,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M349.6,164.7c0,0-1.6,2.9-3.1,4.3c0.8,0.9,2.4,0.6,2.4,0.6L349.6,164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M352.5,172.5c-0.4,0-0.8,0-1.2,0c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c3,0.2,4.7-1.8,4.7-1.8 c0.1-0.1,0.2-0.1,0.3,0c0.1,0.1,0.1,0.2,0,0.3C356.4,170.6,355,172.2,352.5,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M369.8,170.4c-0.8,1.7-2.2,2.7-3.5,3.1c-1.9,0.5-2.8-1.7-2.1-3.9c0.6-2,2.3-4.6,4.1-4.2 C370.2,165.9,370.7,168.5,369.8,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M358.3,160.1c-0.1,0-0.2,0-0.3-0.1c-1.2-1.3-2.7-1-2.7-1c-0.2,0-0.4-0.1-0.5-0.3c0-0.2,0.1-0.4,0.4-0.5 c0.1,0,1.9-0.4,3.4,1.3c0.1,0.2,0.1,0.4,0,0.6C358.5,160,358.4,160.1,358.3,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M345.6,159.3c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.4,0-0.6c1.6-1.8,3.4-1.6,3.5-1.6c0.2,0,0.4,0.2,0.3,0.5 c0,0.2-0.3,0.4-0.5,0.4c-0.1,0-1.5-0.1-2.8,1.3C345.8,159.3,345.7,159.3,345.6,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M355.5,162.6l-1.6-0.6C353.9,162,354.5,163.3,355.5,162.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M357.9,152.4c0,0,2.5,11.1,10.6,12.3c8.1,1.2,6.2-10.8-4.6-15.2c-10.9-4.4-19.7,4.4-20.2,6.7 s1.7,3.9,1.7,3.9S349.4,152.6,357.9,152.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M364.3,419.3l-1.4,0l-0.4-1.8l-4.7,2.1h-12c0,0-1.9-1.9,3.8-3.4c0.3-0.1,0.5-0.2,0.8-0.3 c3.1-1.4,7.4-6.3,7.4-6.3h6.6c0,0,0.2,0.3,0.5,0.9C365.6,412,366.8,415.1,364.3,419.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M364.9,410.6C364.9,410.6,364.9,410.6,364.9,410.6c-0.9-0.9-4.8,3.3-7.7,4.8c-2.6,1.3-5.5,1.9-6.8,0.6 c3.1-1.4,7.8-7.7,7.8-7.7h5.3C363.5,408.2,364.6,410,364.9,410.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M314.3,419.3l-1.4,0l-0.4-1.8l-4.7,2.1h-12c0,0-1.9-1.9,3.8-3.4c0.3-0.1,0.5-0.2,0.8-0.3 c3-1.4,7.4-6.3,7.4-6.3h6.6c0,0,0.2,0.3,0.5,0.9C315.6,412,316.8,415.1,314.3,419.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M314.8,410.6C314.8,410.6,314.8,410.6,314.8,410.6c-0.9-0.9-4.8,3.3-7.7,4.8c-2.6,1.3-5.5,1.9-6.8,0.6 c3-1.4,7.8-7.7,7.8-7.7h5.3C313.5,408.2,314.5,410,314.8,410.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M336.2,242.1h34.1l0.9,4.4c0,0,12.5,17.4,6.2,60.6c0,0-27.5,3.2-53.3-2.4c0,0,5.8-44.4,11.9-58.9 L336.2,242.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "360.1,245.9 371.6,245.9 370.9,242.6 360.1,242.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "339.3,242.6 335.9,242.6 335.6,245.9 339.3,245.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.5,
    y: 242.6,
    className: "st7",
    width: 18.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "360.1,245.9 371.6,245.9 370.9,242.6 360.1,242.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "339.3,242.6 335.9,242.6 335.6,245.9 339.3,245.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.5,
    y: 242.6,
    className: "st12",
    width: 18.5,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M350.8,246.2h-5.1c-0.3,0-0.6-0.3-0.6-0.6V243c0-0.3,0.3-0.6,0.6-0.6h5.1c0.3,0,0.6,0.3,0.6,0.6v2.6 C351.3,245.9,351.1,246.2,350.8,246.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M381.9,202.3c0.8,2.1,1.4,4.2,2.1,6.3c0.6,2.1,1.2,4.2,1.7,6.3c0.5,2.1,1,4.2,1.5,6.4 c0.5,2.1,0.8,4.3,1.2,6.5l0,0.3c0,0.2,0.1,0.5,0.1,0.7c0,1.3-0.5,2.9-1.3,4c-0.8,1.2-1.8,1.9-2.7,2.4c-1.7,0.9-3.2,1.2-4.5,1.4 c-2.6,0.4-4.9,0.2-7.2,0c-2.2-0.2-4.4-0.6-6.5-1.1c-2.1-0.5-4.2-1-6.3-1.7c-1.4-0.5-2.1-2-1.7-3.3c0.4-1.1,1.4-1.8,2.6-1.8l0.1,0 c2,0.1,4.1,0.1,6.1,0.1c2,0,4,0,6-0.1c1.9-0.1,3.8-0.3,5.3-0.7c0.7-0.2,1.3-0.5,1.4-0.6c0-0.1-0.1,0-0.4,0.3 c-0.2,0.3-0.4,0.8-0.4,1.1l0.1,1c-1-4-2.1-8-3.3-11.9l-1.8-5.9l-1.9-5.9l0-0.1c-0.9-2.8,0.7-5.8,3.5-6.6 C378.1,198.2,381,199.7,381.9,202.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.7,192.5c5.7,0.9,8.8,5.3,13.5,16.8c-5.4,9.3-13.4,10.5-13.4,10.5S365.8,205.7,373.7,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M373.7,192.5c5.7,0.9,8.8,5.3,13.5,16.8c-5.4,9.3-13.4,10.5-13.4,10.5S365.8,205.7,373.7,192.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M351,206.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C350.7,205.4,351,205.7,351,206.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M349.6,215.8c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C349.3,215.2,349.6,215.5,349.6,215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M348.9,226.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C348.6,225.4,348.9,225.7,348.9,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M348.9,236.9c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C348.6,236.2,348.9,236.5,348.9,236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M294,194.2l-14,6.4l-2.1,0.1l1.5-1.5l14-6.4c0.3-0.1,0.6,0,0.7,0.3l0.2,0.4 C294.4,193.8,294.3,194.1,294,194.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05FatcaDetails);
export default __webpack_public_path__ + "static/media/05_Fatca_details.71c5a1759ea7c8e466b4779249527a4e.svg";
export { ForwardRef as ReactComponent };